import jwtDecode from 'jwt-decode';

import { refreshToken } from './refreshToken';
import { getAccessToken } from '../token';

/**
 * Get token expire time left in millisecond
 *
 * @param {string}    jwtToken    JWT Token
 * @returns {number}  Expire time left (milliseconds)
 */
export function getJwtExpiredLeft(jwtToken) {
  const data = jwtDecode(jwtToken);
  return data.exp - Date.now() / 1000;
}

/**
 * Get refresh token expire time left in millisecond
 *
 * @returns {number?}  Expire time left (milliseconds)
 */
export function getAccessTokenJwtExpiredLeft() {
  const accessToken = getAccessToken();

  if (!accessToken) {
    return null;
  }
  return getJwtExpiredLeft(accessToken);
}

/**
 * Get token expire time left in millisecond
 *
 * @param {number}    seconds    Remove seconds from timeout
 */
export function setTimeoutRefreshToken(seconds) {
  const { timeoutRefreshToken } = window;
  if (timeoutRefreshToken) {
    clearTimeout(timeoutRefreshToken);
  }

  const jwtExpiredLeft = getAccessTokenJwtExpiredLeft();
  if (jwtExpiredLeft === null) {
    return;
  }

  const timeoutSeconds = jwtExpiredLeft - seconds;

  window.timeoutRefreshToken = setTimeout(
    () => {
      refreshToken().then(() => {
        // If not cleared continue setTimeout
        if (timeoutRefreshToken) {
          setTimeoutRefreshToken(seconds);
        }
      });
    },
    timeoutSeconds > 0 ? timeoutSeconds * 1000 : 0
  );
}

/**
 * Clear timeout refreshToken
 */
export function clearTimeoutRefreshToken() {
  const { timeoutRefreshToken } = window;
  if (timeoutRefreshToken) {
    clearTimeout(timeoutRefreshToken);
  }
  window.timeoutRefreshToken = null;
}
